






















import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {EmployeeStore} from "@/modules/employees/store";
import debounce from "lodash/debounce";
import EmployeeLabel from "@/modules/employees/List/components/Label.vue";
import {EmployeeParams} from "@/modules/employees/params";
import {CommonStatus} from "@/enums/status";

@Component({
    name: "EmployeeSelector",
    components: {EmployeeLabel}
})
export default class extends Vue {
    @Model("change")
    readonly accountRowGuid!: string|string[];

    @Emit('change')
    handleChange(value: number) {
        if (value == undefined) {
            this.onSearch(value);
        }
        return value;
    }

    @Prop({ type: Number, default: undefined })
    readonly type!: number;

    @Prop({ default: "default", type: String })
    readonly mode!: string;

    @Prop({ default: false })
    readonly disabled!: boolean;

    @Prop({ default: "Chọn nhân viên", type: String })
    readonly placeholder!: string;

    ids: string[] = [];

    async created() {
        try {
            const params = { ...new EmployeeParams(), limit: 100, status: CommonStatus.Active, type: this.type };
            await EmployeeStore.listEmployee({ params });
            this.ids = this.type? EmployeeStore.type[this.type] : EmployeeStore.ids;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã có lỗi xảy ra");
        }
    }

    handleSearch = debounce(async (value: string, vm: any) => {
        debugger
        const params = {...new EmployeeParams(), limit: 100, search: value, status: CommonStatus.Active, type: vm.type};
        await EmployeeStore.listEmployee({ params, refresh: true });
        vm.ids = vm.type? EmployeeStore.type[vm.type] : EmployeeStore.ids;
        console.log("ids" ,vm.ids);
    }, 500);

    onSearch(val: any) {
        this.handleSearch(val, this);
    }
}
